import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getWebNotificationList = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  const url = queryString
    ? `/web-notification/user?${queryString}`
    : '/web-notification/user';
  return serviceHelper(http.get(url), false);
};

export const clearWebNotifications = async () => {
  return serviceHelper(http.delete('/web-notification/user/clear'), false);
};

export const markWebNotificationRead = async (id: string) => {
  return serviceHelper(http.patch(`/web-notification/user/${id}/read`), false);
};
